import { render, staticRenderFns } from "./QuestionItem.vue?vue&type=template&id=a1f2222e&scoped=true"
import script from "./QuestionItem.ts?vue&type=script&lang=ts&external"
export * from "./QuestionItem.ts?vue&type=script&lang=ts&external"
import style0 from "./QuestionItem.vue?vue&type=style&index=0&id=a1f2222e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f2222e",
  null
  
)

export default component.exports